import React, { Component } from 'react'
import DailyForecast from './DailyForecast';

export default class DailyForecastWrapper extends Component {
    render() { return (<div >  <DailyForecast row={this.props.row} called={this.props.called} data={this.props.data} handleCalled={this.props.handleCalled} zoom_data={this.props.zoom_data} /></div>) }
}
